import { makeStyles } from '@material-ui/core/styles';
export default makeStyles(function (theme) { return ({
    card: {
        boxShadow: 'none',
        borderRadius: '0',
    },
    actions: {
        padding: theme.spacing(1, 3),
        cursor: 'pointer',
        backgroundColor: theme.palette.fill.secondary,
    },
    content: {
        backgroundColor: theme.palette.common.white,
        borderTop: 'transparent',
        borderBottomLeftRadius: '8px',
        borderBottomRightRadius: '8px',
        padding: theme.spacing(1.5, 3),
    },
    expand: {
        transform: 'rotate(0deg)',
        color: theme.palette.common.black,
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    collapse: {
        backgroundColor: 'transparent',
    },
    title: {
        display: 'flex',
        flexGrow: 1,
        fontSize: '19px',
        lineHeight: '32px',
        letterSpacing: '-0.028em',
        alignItems: 'center',
    },
}); });
